module.exports = "<h2 mat-dialog-title>Error</h2>\n<mat-dialog-content class=\"error\">{{data.errorMsg}}</mat-dialog-content>\n<mat-dialog-actions>\n    <button mat-raised-button (click)=\"closeDialog()\">Ok</button>\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/error-dialog.component.html
// module id = ./src/app/core/error-dialog.component.html
// module chunks = main